"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { alert: null };
        GState.bind(this, [
            'tenant',
            'user'
        ]);
        this.loadPricing();
    },
    loadPricing: function () {
        if (!this.state.user || !this.state.user.accounttype)
            return;
        const accounttype = this.state.user.accounttype.toLowerCase();
        if (!this.state.tenant.settings.pricing || !this.state.tenant.settings.pricing[accounttype])
            return;
        this.pricing = this.state.tenant.settings.pricing[accounttype];
    },
    onSubscribed: async function () {
        await GState.user.refresh();
        this.state.alert = {
            title: 'Congratulation!',
            message: `You have subscribed to <b>${ this.state.user.subscription.type }</b> package successfully.`
        };
        setTimeout(() => document.location = '/', 11 * 1000);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/BillPayment/Instructor/Subscription.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Extension_template = require("../../../../components/Extension/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Extension_tag = marko_loadTag(Extension_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "position-relative d-flex align-items-center top-0 w-100 vh-100 zindex-5"
      },
    marko_attrs1 = {
        "class": "w-100"
      },
    marko_attrs2 = {
        "class": "text-center"
      },
    marko_attrs3 = {
        "class": "font-medium-4"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("2c1bcd"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "d-flex justify-content-center"
      },
    marko_attrs5 = {
        "class": "col-10"
      },
    marko_attrs6 = {
        "class": "text-center"
      },
    marko_node2 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "font-medium-5"
      },
    marko_node4 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        if (component.pricing && component.pricing.enabled) {
          if (state.alert) {
            out.be("div", marko_attrs2, "3", component);

            out.e("h3", null, "4", component, 1)
              .t(state.alert.title, component);

            out.be("p", marko_attrs3, "5", component);

            out.h(state.alert.message, component);

            out.ee();

            out.ee();

            out.n(marko_node0, component);

            out.n(marko_node1, component);
          }

          _preserve_tag({
              n: true,
              i:  state.alert ,
              renderBody: function(out) {
                out.be("div", marko_attrs4, "@pricings", component);

                out.be("div", marko_attrs5, "8", component);

                Extension_tag({
                    name: "Subscribe",
                    payload: {
                        action: "showcase",
                        reference: component.pricing.reference
                      }
                  }, out, __component, "9", [
                  [
                    "done",
                    "onSubscribed",
                    false
                  ]
                ]);

                out.ee();

                out.ee();
              }
            }, out, __component, "pricings");
        } else {
          out.be("div", marko_attrs6, "10", component);

          Bx_tag({
              type: "dollar-circle",
              class: "font-large-4 text-info"
            }, out, __component, "11");

          out.n(marko_node2, component);

          out.n(marko_node3, component);

          out.be("p", marko_attrs7, "14", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("No subscription requirements");
              }
            }, out, __component, "15");

          out.ee();

          out.n(marko_node4, component);

          out.n(marko_node5, component);

          route_link_tag({
              type: "button",
              href: "/",
              class: "btn btn-primary btn-lg",
              renderBody: function(out) {
                Locale_tag({
                    text: "Go back"
                  }, out, __component, "19");
              }
            }, out, __component, "18");

          out.ee();
        }

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
